<template>
  <div class="container">
    <p class="titleMain">Клиенты</p>

    <p v-if="clientsList.length == 0" style="text-align: center">
      Список клиентов пуст
    </p>
    <ClientListItem
      v-for="(client, index) in clientsList" :key="index"
      :clientInfo="client"
    ></ClientListItem>

    
  </div>
</template>
<script>
import ClientListItem from "@/components/clients/clientListItem";
export default {
  components: { ClientListItem },
  data: function () {
    return {
      clientsList: [],
    };
  },
  methods: {
    startComponent() {
      this.$store.dispatch('GET_CLIENTS_LIST').then(r=>{
        this.clientsList = r.data.data;
      })
    },
    deleteItem(){
      this.startComponent()
    }
  },
  created: function () {
     this.startComponent()
  },
};
</script>
